import { render } from "./ChatbotDashboard.vue?vue&type=template&id=760fb1d8&scoped=true"
import script from "./ChatbotDashboard.vue?vue&type=script&lang=js"
export * from "./ChatbotDashboard.vue?vue&type=script&lang=js"

import "./ChatbotDashboard.vue?vue&type=style&index=0&id=760fb1d8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760fb1d8"]])

export default __exports__